

/* 合法uri */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

// 导出或下载文件
export function downloadFile(url) {
  if (!url) {
    console.warn('downloadFile url missing')
    return false
  }
  var $a = document.createElement('a')
  $a.setAttribute('href', url)
  $a.setAttribute('download', '')
  $a.setAttribute('mce_href', '#')
  var evObj = document.createEvent('MouseEvents')
  evObj.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  $a.dispatchEvent(evObj)
}

// 清除切换时提示
export const clearError = function (fields) {
  fields.map(item => {
    item.validateState = ''
    item.validateMessage = ''
  })
}

export function realName(str) {
  // const reg = /^[\u4e00-\u9fa5]{0,4}$/;
  // return reg.test(str)
  if (str && str.trim().length >= 2
  ) {
    return true
  }
  return false
}

export function mobile(str) {
  // const reg = /^1\d{10}$/;
  const reg = /^1[3456789]\d{9}$/
  return reg.test(str)
}

export function idNum(str) {
  const reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(str)
}
export function num(str) {
  const reg = /^[0-9]+$/;
  return reg.test(str)
}